import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";

export const Footer = () => {
  return (
    <Box>
      <Divider />
      <Box
        mt={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{ xs: "column", md: "row" }}
      >
        <Box flexGrow={0} flexShrink={0}>
          <Typography
            variant="subtitle2"
            color="textSecondary"
            gutterBottom={true}
          >
            &copy; 2024 Quantifiction, Inc. All rights reserved.
          </Typography>
        </Box>
        <Box display="flex" flexWrap="wrap" alignItems="center">
          <Typography variant="subtitle2">
            <Link component={RouterLink} to="/terms">
              Terms & Conditions
            </Link>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Link component={RouterLink} to="/privacy">
              Privacy Policy
            </Link>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Link component={RouterLink} to="/rai">
              Quantifiction's Use Of AI
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageWrapper/Footer.tsx